import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  UntypedFormBuilder,
} from "@angular/forms";
import { DaoService } from "src/app/services/dao.service";
import * as jwtDecode from "jwt-decode";
import { LstorageService } from "src/app/services/lstorage.service";
import { ToastService } from "src/app/services/toast.service";
import { MatDialogRef } from "@angular/material/dialog";
//import { Ng2SearchPipeModule } from 'ng2-search-filter';
@Component({
  selector: "app-userconfig",
  templateUrl: "./userconfig.component.html",
  styleUrls: ["./userconfig.component.scss"],
})
export class UserconfigComponent implements OnInit {
  userid: any;
  modified_By: any;
  created_By: any;
  dataSource: any;
  requiredUserconfig: any;
  configure: any;
  user: any;
  paginator: any;
  userList: any[];
  adminRepositoryselected = [];
  adminEntityAnalyticsselected = [];
  adminreposearch;
  public validator = {
    errorMessage: "",
    UniqueUserconfig: false,
  };
  searchText: any;

  Userconfig = new FormGroup({
    userId: new FormControl(),
    userCases: new FormControl(),
    userRepository: new FormControl(),
    casesMonitoring: new FormControl(),
    emailAccount: new FormControl(),
    liveMonitoring: new FormControl(),
    adminreposearch: new FormControl(),
    adminRepository: new FormControl(),
    adminEntityAnalytics: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  AdminRepository: any;
  AdminEntityAnalytics: string[] = [
    "Personal info",
    "Relations",
    "Account",
    "Time Line",
  ];
  adminRepository: any;

  constructor(
    private daoService: DaoService,
    private token: LstorageService,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<UserconfigComponent>,
    private toast: ToastService
  ) {
    this.Userconfig = this.fb.group({
      userId: [""],
      userCases: ["", [Validators.required]],
      userRepository: ["", [Validators.required]],
      casesMonitoring: [""],
      emailAccount: [""],
      liveMonitoring: ["true"],
      adminreposearch: [],
      adminRepository: [""],
      adminEntityAnalytics: [""],
      isActive: ["true"],
      createdBy: [""],
      createdOn: ["2020-01-21T16:37:44.849Z"],
    });

    this.daoService.fuserId.subscribe((data: any) => {
      this.userid = data;
    });

    if (this.userid) {
      //For Admin repo
      this.daoService.getRepositoryByUserId(this.userid).subscribe(
        (data: any) => {
          this.AdminRepository = data;
          console.log("adminrepo");
          console.log(this.AdminRepository);
        },
        (err) => {
          console.log(err);
        }
      ); // If got an error);

      this.modified_By = jwtDecode(this.token.getToken());
      this.daoService.getUserconfigById(this.userid).subscribe(
        (data: any) => {
          if (data) {
            if (data.adminRepository != null) {
              this.adminRepositoryselected = data.adminRepository;
            }

            if (data.adminEntityAnalytics != null) {
              this.adminEntityAnalyticsselected = data.adminEntityAnalytics;
            }
            if (data.userId != null) {
              this.Userconfig = this.fb.group({
                userId: [this.userid],
                userCases: [data.userCases],
                userRepository: [data.userRepository],
                casesMonitoring: [data.casesMonitoring],
                emailAccount: [data.emailAccount],
                liveMonitoring: ["true"],
                adminreposearch: [],
                adminRepository: [data.adminRepository],
                adminEntityAnalytics: [data.adminEntityAnalytics],
                isActive: ["true"],
                createdBy: [""],
                createdOn: ["2020-01-21T16:37:44.849Z"],
                modifiedBy: [this.modified_By.unique_name],
                modifiedOn: ["2020-01-21T16:37:44.849Z"],
              });
            } else {
              this.Userconfig = this.fb.group({
                userId: [this.userid],
                userCases: [],
                userRepository: [],
                casesMonitoring: ["0"],
                emailAccount: ["0"],
                liveMonitoring: ["true"],
                adminreposearch: [],
                adminRepository: [],
                adminEntityAnalytics: [],
                isActive: ["true"],
                createdBy: [""],
                createdOn: ["2020-01-21T16:37:44.849Z"],
                modifiedBy: [this.modified_By.unique_name],
                modifiedOn: ["2020-01-21T16:37:44.849Z"],
              });
            }
          }
        },

        (error) => {
          console.log("Error:" + error);
        }
      );
    }
  }

  ngOnInit() {}

  checkedadminRepository(adminRepository) {
    if (this.adminRepositoryselected) {
      if (
        this.adminRepositoryselected.findIndex(
          (x) => x.key === adminRepository
        ) != -1
      ) {
        return true;
      }
    }
  }

  checkedadminEntityAnalytics(adminEntityAnalytics) {
    if (this.adminEntityAnalyticsselected) {
      if (
        this.adminEntityAnalyticsselected.findIndex(
          (x) => x.key === adminEntityAnalytics
        ) != -1
      ) {
        return true;
      }
    }
  }

  repositoryChange(event, repository) {
    var repositoryobj = {
      key: repository,
      IsSelect: true,
    };
    console.log("Repository change");
    console.log(repositoryobj);

    if (event) {
      this.adminRepositoryselected.push(repositoryobj);
    } else {
      var index = this.adminRepositoryselected.findIndex(
        (x) => x.key === repository
      );
      this.adminRepositoryselected.splice(index, 1);
    }
    this.Userconfig.value.adminRepository = this.adminRepositoryselected;
    console.log(this.Userconfig.value);
  }

  analyticsChange(event, analytics) {
    if (event) {
      var analyticsobj = {
        key: analytics,
        IsSelect: true,
      };
      this.adminEntityAnalyticsselected.push(analyticsobj);
    } else {
      var index = this.adminEntityAnalyticsselected.findIndex(
        (x) => x.key === analytics
      );
      this.adminEntityAnalyticsselected.splice(index, 1);
    }
    this.Userconfig.value.adminEntityAnalytics =
      this.adminEntityAnalyticsselected;
    console.log(this.Userconfig.value);
  }

  createUserconfig() {
    this.created_By = jwtDecode(this.token.getToken());
    this.validator.UniqueUserconfig = false;
    this.Userconfig.value.userId = this.userid;
    // this.Userconfig.value.created_By = this.created_By.unique_name;
    // this.Userconfig.value.modified_By = this.modified_By.unique_name;
    this.Userconfig.value.liveMonitoring = true;
    this.Userconfig.value.isActive = true;
    this.Userconfig.value.createdOn = "2020-01-31T15:36:13.176Z";
    this.Userconfig.value.modifiedOn = "2020-01-31T15:36:13.176Z";
    this.created_By = jwtDecode(this.token.getToken());
    this.daoService.AddUserconfig(this.Userconfig.value).subscribe(
      (data: any) => {
        if (data.isSuccess) {
          this.daoService.dynamicUserList(data.data);
          this.toast.openSnackBar("User config added successfully", "close");
        }
        this.dialogRef.close();
      },
      (error) => {
        console.log(error);
        this.validator.UniqueUserconfig = true;
        this.validator.errorMessage = error.error.userMessage;
      }
    );
  }
  Userconfigchange(id) {
    this.daoService.getUserconfigById(id).subscribe((data) => {
      this.requiredUserconfig = data;
    });
  }
  public RepositoryFilter = (value: string) => {
    // this.AdminRepository =  this.adminRepository.filter(x => x.value == this.AdminRepository)[0];

    this.AdminRepository = this.AdminRepository.filter(function (el) {
      console.log("el");
      console.log(el);
      return el === value;
    });
    console.log(this.AdminRepository);
  };

  // public AnalyticsFilter = (value: string[]) => {
  //   this.AdminEntityAnalytics.filter = value.trim().toLocaleLowerCase();
  // }
  closeUserconfigForm() {
    this.dialogRef.close();
  }

  configFilter(value) {
    this.daoService.getRepositoryByUserId(this.userid).subscribe(
      (data: any) => {
        this.AdminRepository = data;
        console.log("adminrepo");
        console.log(this.AdminRepository);
        var result = this.AdminRepository.filter((repo) =>
          repo.templateName.toLowerCase().includes(value.toLowerCase())
        );
        this.AdminRepository = result;
      },
      (err) => {
        console.log(err);
      }
    ); // If got an error);
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
